<template>
    <div class="page-content">
        <div class="section main-section">
            <h1>Explore Itineraries</h1>
            <p>We keep a vitrual diary of your trips for you to share and reminisce.</p>

            <div class="filter dropdown-container">
                <input type="text" placeholder="Get inspiration from other itineraries" />
                <button class="filter-btn dropdown-trigger">
                    <i class="filter-icon"></i> Filter
                </button>

                <div class="dropdown filter-dropdown hidden">
                    <div class="dropdown-section season-and-length">
                        <div class="column">
                            <label class="dropdown-title">Season</label>
                            <div class="field">
                                <select>
                                    <option>Spring</option>
                                    <option selected>Summer</option>
                                    <option>Fall</option>
                                    <option>Winter</option>
                                </select>
                            </div>
                        </div>
                        <div class="column">
                            <label class="dropdown-title">Length of Stay</label>
                            <div class="field">
                                <input type="number" min="1" max="14" maxlength="2" />
                                <span>days</span>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown-section destinations">
                        <label class="dropdown-title">Destinations</label>

                        <div class="options-list">
                            <div class="field">
                                <input type="checkbox" id="dest_afr" name="dest" />
                                <label for="dest_afr">Africa</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="dest_ant" name="dest" />
                                <label for="dest_ant">Antarctica</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="dest_as" name="dest" />
                                <label for="dest_as">Asia</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="dest_oce" name="dest" />
                                <label for="dest_oce">Australia / Oceania</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="dest_eu" name="dest" />
                                <label for="dest_eu">Europe</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="dest_am" name="dest" />
                                <label for="dest_am">Americas</label>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown-section activities">
                        <label class="dropdown-title">Activities</label>

                        <div class="options-list">
                            <div class="field">
                                <input type="checkbox" id="act_adv" name="dest" />
                                <label for="act_adv">Adventure and Outdoors</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_art" name="dest" />
                                <label for="act_art">Arts and Culture</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_ff" name="dest" />
                                <label for="act_ff">Family-Friendly</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_fc" name="dest" />
                                <label for="act_fc">Food Crawling</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_nl" name="dest" />
                                <label for="act_nl">Nightlife</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_rel" name="dest" />
                                <label for="act_rel">Religion and Spirituality</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_rnr" name="dest" />
                                <label for="act_rnr">Rest and Relaxation</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_rom" name="dest" />
                                <label for="act_rom">Romantic</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_shp" name="dest" />
                                <label for="act_shp">Shopping</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_ss" name="dest" />
                                <label for="act_ss">Sightseeing</label>
                            </div>
                            <div class="field">
                                <input type="checkbox" id="act_spr" name="dest" />
                                <label for="act_spr">Sports</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="title-and-sort">
                    <h2>Most Favorited</h2>

                    <div class="dropdown-container">
                        <button class="sort-btn dropdown-trigger">Sort By</button>

                        <div class="dropdown sort-dropdown hidden">
                            <div class="row">Recently Published</div>
                            <div class="row">PlanIt Recommended</div>
                            <div class="row">Top Rated</div>
                            <div class="row">Length of Trip (Low to High)</div>
                            <div class="row">Length of Trip (High to Low)</div>
                            <div class="row">Budget (Low to High)</div>
                            <div class="row">Budget (High to Low)</div>
                        </div>
                    </div>
                </div>

                <div class="itineraries-list">
                    <ItineraryItem v-for="n in 6" v-bind:key="n"></ItineraryItem>
                </div>
            </div>

            <div class="section">
                <h2>Staff Picks</h2>

                <div class="itineraries-list">
                    <ItineraryItem v-for="n in 6" v-bind:key="n"></ItineraryItem>
                </div>
            </div>

            <div class="section">
                <h2>Rare Finds</h2>

                <div class="itineraries-list">
                    <ItineraryItem v-for="n in 6" v-bind:key="n"></ItineraryItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ExploreItineraries',
        components: {
            ItineraryItem: require('./itineraryItem').default
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'explore-itineraries'
        },
        mounted: function() {
            let dropdownTriggers = document.querySelectorAll('.dropdown-trigger')

            dropdownTriggers.forEach(dropdownTrigger => dropdownTrigger.addEventListener('click', () => {
                let dropdown = dropdownTrigger.closest('.dropdown-container')
                    .querySelector('.dropdown')
                dropdown.classList.toggle('hidden')
                let dropdownLeft = dropdownTrigger.offsetLeft

                if (dropdownLeft > window.innerWidth / 2) {
                    dropdownLeft += dropdownTrigger.clientWidth - dropdown.clientWidth
                }

                dropdown.style.left = `${dropdownLeft}px`
            }))
        }
    }
</script>

<style scoped lang="scss">
    .filter {
        display: flex;
        justify-content: center;
        margin: 27px auto 0;
        padding: 0 15px;

        @media all and (max-width: $breakpoint) {
            flex-wrap: wrap;
            padding: 0;
        }
    }


    .filter [type="text"] {
        padding: 0 24px;
        width: 100%;
        max-width: 652px;
        height: 48px;
        line-height: 48px;
        font-weight: $medium;
        font-size: 14px;
        border: 1px solid $light-gray;

        @media all and (max-width: $breakpoint) {
            padding: 0 15px;
        }
    }


    .filter-btn {
        height: 48px;
        line-height: 48px;
        border: 1px solid $light-gray;

        @media all and (min-width: $breakpoint + 1) {
            width: 122px;
            border-left-width: 0;
        }

        @media all and (max-width: $breakpoint) {
            width: 100%;
            border-top-width: 0;
            border-left-width: 1px;
        }
    }

    .filter-btn .filter-icon {
        margin-right: 8.5px;
        width: 16px;
        height: 16px;
    }


    .title-and-sort {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        max-width: calc(1210px - 36px);
    }


    .filter-dropdown {
        background-color: #FFF;
        width: 100%;
        font-size: 12px;
        color: #353535;
        box-shadow: 0 0 10px $gray;

        @media all and (min-width: $breakpoint + 1) {
            padding: 40px 32px 25px;
            max-width: 432px;
        }

        @media all and (max-width: $breakpoint) {
            padding: 10px 25px 20px;
            max-width: none;
        }
    }


    .section .section {

        @media all and (max-width: $breakpoint) {
            padding-left: 0;
            padding-right: 0;
        }
    }


    .section .title-and-sort h2 {
        margin: 0;
    }


    .title-and-sort .dropdown-container {
        width: 100%;
        max-width: 231px;

        @media all and (max-width: $breakpoint) {
            max-width: 92px;
        }
    }


    .title-and-sort .sort-btn {
        background-color: #FFF;
        padding: 0 18px;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: left;
        font-family: inherit;
        font-weight: $book;
        font-size: 12px;
        border: 1px solid $light-gray;
        border-radius: 0;

        @media all and (max-width: $breakpoint) {
            padding: 0 10px;
        }
    }


    .dropdown-section:not(:first-child) {
        margin-top: 24px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }

    .season-and-length {
        display: flex;

        @media all and (max-width: $breakpoint) {
            flex-wrap: wrap;
        }
    }


    .season-and-length > div {
        width: 50%;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            min-width: 50%;
            width: auto;
        }
    }


    .filter-dropdown .dropdown-title {
        text-transform: uppercase;
        font-weight: $heavy;
    }


    .season-and-length .field {
        position: relative;
        display: block;
        margin-top: 8px;
        width: max-content;
    }


    .season-and-length .field span {
        position: absolute;
        top: 0;
        right: 18px;
        bottom: 0;
        line-height: 36px;
    }

    .season-and-length select,
    .season-and-length [type="number"] {
        padding: 0 18px;
        width: 108px;
        height: 36px;
        line-height: 36px;
        font-weight: $book;
        font-size: inherit;
        border: 1px solid $light-gray;
        border-radius: 0;
    }

    .season-and-length [type="number"] {
        padding-right: calc(24px + 18px + 8px);
    }


    .dropdown-section .options-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

        @media all and (max-width: $breakpoint) {
            &.options-list {
                margin-top: 10px;
                flex-wrap: nowrap;
                height: auto;
            }
        }
    }

    .destinations .options-list {
        height: 108px;
    }

    .activities .options-list {
        height: 216px;
    }


    .dropdown-section:not(.season-and-length) .field {
        position: relative;
        width: 50%;
        margin: 8px 0;

        @media all and (max-width: $breakpoint) {
            margin: 0;
            width: 100%;

            &:not(:first-child) {
                margin-top: 5px;
            }
        }
    }

    .dropdown-section:not(.season-and-length) [type="checkbox"] {
        position: absolute;
        left: 0;
    }


    .dropdown-section .field label {
        position: relative;
    }

    .dropdown-section .field label::before {
        content: "";
        background-color: #FFF;
        display: inline-block;
        vertical-align: middle;
        margin-right: 12px;
        width: 20px;
        height: 20px;
        border: 1px solid $light-gray;
        transition: all 200ms ease;
    }

    .field [type="checkbox"]:checked + label::before {
        background-color: $light-blue;
        border-color: $light-blue;
    }

    .dropdown-section .field label::after {
        content: "";
        background-color: $accent;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 4px;
        width: 12px;
        height: 12px;
        opacity: 0;
        transition: opacity 200ms ease;
    }

    .field [type="checkbox"]:checked + label::after {
        opacity: 1;
    }


    .sort-dropdown {
        top: calc(100% - 1px);
        width: 100%;
        font-size: 12px;
        border: 1px solid $light-gray;

        @media all and (max-width: $breakpoint) {
            left: calc(-100% - 1px) !important;
            width: max-content;
        }
    }


    .sort-dropdown .row {
        padding: 0 18px;
        height: 36px;
        line-height: 36px;
        cursor: pointer;
    }

    .sort-dropdown .row:nth-child(odd) {
        background-color: #F6F6F6;
    }

    .sort-dropdown .row:nth-child(even) {
        background-color: #FFF;
    }

    .sort-dropdown .row:not(:first-child) {
        border-top: 1px solid $light-gray;
    }

    .sort-dropdown .row:hover {
        background-color: hsl(32, 100%, 80%);
    }
</style>
